module.exports = __webpack_public_path__ + "img/60.c971eaf4.png";